<template>
    <div class="mines-controls">
        <!-- Mobile: Place Bet at top (above Manual/Auto) -->
        <div class="place-bet-row place-bet-row-mobile">
            <button v-if="minesGame === null || minesGame.state === 'completed'" v-on:click="minesBetButton()" class="button-bet" v-bind:disabled="socketSendLoading !== null">
                <div class="button-inner">
                    <transition name="fade" mode="out-in">
                        <ButtonLoading v-if="socketSendLoading === 'MinesBet'" />
                        <div v-else class="inner-content">PLACE BET</div>
                    </transition>
                </div>
            </button>
            <button v-else v-on:click="minesCashoutButton()" class="button-cashout" v-bind:disabled="socketSendLoading !== null">
                <div class="button-inner">
                    <transition name="fade" mode="out-in">
                        <ButtonLoading v-if="socketSendLoading === 'MinesCashout'" />
                        <div v-else class="inner-content">
                            CASHOUT
                            <div class="content-amount">
                                <IconCoin />
                                <div class="amount-value">
                                    <span>{{ minesFormatValue(minesGetCashoutAmount).split('.')[0] }}</span>.{{ minesFormatValue(minesGetCashoutAmount).split('.')[1] }}
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </button>
        </div>
        <div class="top-bet-section">
            <div class="bet-label">Your Bet</div>
            <div class="bet-input-container">
                <div class="bet-icon-wrapper">
                    <IconCoin />
                </div>
                <div class="bet-separator"></div>
                <div class="bet-value-display" @click="focusBetInput">
                    <input 
                        ref="betInput"
                        v-model="minesAmount" 
                        v-on:input="minesValidateInput" 
                        v-on:change="minesFormatInput"
                        type="text" 
                        inputmode="decimal"
                        autocomplete="off"
                        class="bet-value-input"
                        placeholder="0.00"
                        aria-label="Bet amount"
                        v-bind:disabled="isInputDisabled"
                        @click.stop
                    />
                </div>
            </div>
            <div class="bet-quick-actions">
                    <button v-on:click="minesSetAmount('min')" class="quick-action-btn" v-bind:disabled="minesGame !== null && minesGame.state !== 'completed'">
                        MIN
                    </button>
                    <button v-on:click="minesSetAmount('1/2')" class="quick-action-btn" v-bind:disabled="minesGame !== null && minesGame.state !== 'completed'">
                        1/2
                    </button>
                    <button v-on:click="minesSetAmount('2x')" class="quick-action-btn" v-bind:disabled="minesGame !== null && minesGame.state !== 'completed'">
                        X2
                    </button>
                    <button v-on:click="minesSetAmount('max')" class="quick-action-btn max-btn" v-bind:disabled="minesGame !== null && minesGame.state !== 'completed'">
                        MAX
                    </button>
                </div>
        </div>
        <div class="controls-tabs">
            <button 
                v-on:click="setTab('manual')" 
                class="tab-button" 
                v-bind:class="{ 'tab-active': currentTab === 'manual' }"
                v-bind:disabled="minesGame !== null && minesGame.state !== 'completed'"
            >
                <div class="tab-inner">Manual</div>
            </button>
            <button 
                v-on:click="setTab('auto')" 
                class="tab-button" 
                v-bind:class="{ 'tab-active': currentTab === 'auto' }"
                v-bind:disabled="minesGame !== null && minesGame.state !== 'completed'"
            >
                <div class="tab-inner">Auto</div>
            </button>
        </div>
        <div class="controls-top">
            <div class="top-mines">
                <div class="mines-label">Mines</div>
                <div class="mines-slider-container">
                    <div class="slider-end-label slider-min mines-display">{{ minesCount }}</div>
                    <div class="top-slider" v-bind:style="{ '--slider-value': minesCount }">
                        <input 
                            v-model.number="minesCount" 
                            type="range" 
                            min="1" 
                            max="24" 
                            step="1" 
                            v-bind:disabled="minesGame !== null && minesGame.state !== 'completed'"
                        />
                    </div>
                    <div class="slider-end-label slider-max">24</div>
                </div>
            </div>
            <button v-if="minesGame === null || minesGame.state === 'completed'" v-on:click="minesBetButton()" class="button-bet button-bet-desktop" v-bind:disabled="socketSendLoading !== null">
                <div class="button-inner">
                    <transition name="fade" mode="out-in">
                        <ButtonLoading v-if="socketSendLoading === 'MinesBet'" />
                        <div v-else class="inner-content">PLACE BET</div>
                    </transition>
                </div>
            </button>
            <button v-else v-on:click="minesCashoutButton()" class="button-cashout button-cashout-desktop" v-bind:disabled="socketSendLoading !== null">
                <div class="button-inner">
                    <transition name="fade" mode="out-in">
                        <ButtonLoading v-if="socketSendLoading === 'MinesCashout'" />
                        <div v-else class="inner-content">
                            CASHOUT
                            <div class="content-amount">
                                <IconCoin />
                                <div class="amount-value">
                                    <span>{{ minesFormatValue(minesGetCashoutAmount).split('.')[0] }}</span>.{{ minesFormatValue(minesGetCashoutAmount).split('.')[1] }}
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </button>
            <button v-if="minesGame !== null && minesGame.state !== 'completed' && currentTab === 'manual'" v-on:click="minesRevealButton()" class="button-random" v-bind:disabled="socketSendLoading !== null">
                <div class="button-inner">
                    <transition name="fade" mode="out-in">
                        <ButtonLoading v-if="socketSendLoading === 'MinesReveal'" />
                        <div v-else class="inner-content">
                            RANDOM PICK
                        </div>
                    </transition>
                </div>
            </button>
        </div>
        <!-- <div class="controls-info">
            <button v-on:click="minesFairButton()">
                <div class="button-inner">
                    <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0001 2.30199V3.8031H10.941C9.76198 3.80425 8.60479 3.48508 7.59306 2.87967L6.25388 2.07004C6.17599 2.02293 6.0867 1.99803 5.99567 1.99803C5.90465 1.99803 5.81535 2.02293 5.73747 2.07004L4.40266 2.8753C3.39067 3.48009 2.23365 3.79922 1.05471 3.79872H3.60219e-10V2.30199C-5.0177e-06 2.16926 0.0524184 2.04191 0.145859 1.94765C0.239299 1.85339 0.36619 1.79986 0.49891 1.7987H1.05909C2.32857 1.79901 3.574 1.45247 4.66087 0.796506L6.00005 0L7.33485 0.800882C8.42243 1.45521 9.6674 1.80162 10.9366 1.80308H11.5012C11.6328 1.80533 11.7584 1.85862 11.8515 1.9517C11.9446 2.04478 11.9979 2.17037 12.0001 2.30199Z" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.941 4.81404C9.58091 4.8134 8.2466 4.44276 7.08102 3.74182L6.00005 3.08536L4.91908 3.72869C3.75456 4.43362 2.42034 4.80878 1.05909 4.81404H0V6.12696C0.00306513 7.64623 0.438442 9.13326 1.25526 10.4143C2.07207 11.6953 3.23659 12.7174 4.61273 13.3612L6.00005 14.0045L7.37862 13.3612C8.75673 12.7191 9.92335 11.6976 10.7418 10.4164C11.5603 9.13521 11.9968 7.64729 12.0001 6.12696V4.81404H10.941ZM6.25388 9.19044C6.16095 9.27977 6.03705 9.32966 5.90815 9.32966C5.77924 9.32966 5.65534 9.27977 5.56241 9.19044L4.16196 7.78999L4.86656 7.08539L5.9169 8.13135L7.66746 6.38079L8.37206 7.08539L6.25388 9.19044Z" />
                    </svg>
                    FAIRNESS
                </div>
            </button>
            <button v-on:click="minesMuteButton()">
                <div class="button-inner">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 5.99999C9 4.82334 8.32 3.80665 7.33334 3.31665V4.78999L8.97 6.42665C8.99 6.28665 9 6.14334 9 5.99999Z" />
                        <path d="M10.6667 6.00001C10.6667 6.62666 10.53 7.21666 10.3067 7.76001L11.3167 8.77001C11.75 7.94001 12 7.00001 12 6.00001C12 3.14666 10.0033 0.760007 7.33334 0.153351V1.53001C9.26 2.10335 10.6667 3.88666 10.6667 6.00001Z" />
                        <path d="M6 0.666656L4.60666 2.06L6 3.45334V0.666656Z" />
                        <path d="M0.85 0L0 0.85L3.15 4H0V8H2.66666L6 11.3333V6.85L8.83666 9.68666C8.39 10.03 7.88666 10.3067 7.33331 10.4733V11.85C8.24997 11.64 9.08666 11.22 9.78997 10.6433L11.15 12L12 11.15L6 5.15L0.85 0Z" />
                    </svg>
                    {{ soundMines === 1 ? 'MUTE' : 'UNMUTE' }}
                </div>
            </button>
        </div> -->
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import ButtonLoading from '@/components/ButtonLoading';
    import IconCoin from '@/components/icons/IconCoin';

    export default {
        name: 'MinesControls',
        components: {
            ButtonLoading,
            IconCoin
        },
        data() {
            return {
                minesAmount: '',
                minesCount: 1,
                currentTab: 'manual',
                autoRevealInterval: null
            }
        },
        methods: {
            focusBetInput() {
                if (!this.isInputDisabled && this.$refs.betInput) {
                    this.$refs.betInput.focus();
                }
            },
            ...mapActions([
                'notificationShow',
                'soundSetMines',
                'modalsSetShow',
                'minesSendBetSocket',
                'minesSendRevealSocket',
                'minesSendCashoutSocket'
            ]),
            minesFormatValue(value) {
                return parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },
            minesFormatInput() {
                if(this.minesAmount === null || this.minesAmount === '' || this.minesAmount === undefined) {
                    this.minesAmount = '';
                    return;
                }
                const numValue = parseFloat(this.minesAmount);
                if(isNaN(numValue)) {
                    this.minesAmount = '';
                    return;
                }
                this.minesAmount = numValue.toFixed(2);
            },
            minesValidateInput() {
                if(this.minesAmount === null || this.minesAmount === undefined) {
                    this.minesAmount = '';
                    return;
                }
                const value = String(this.minesAmount);
                if(value === '') {
                    return;
                }
                this.minesAmount = value.replace(',', '.').replace(/[^\d.]/g, '');
                this.minesAmount = this.minesAmount.indexOf('.') >= 0 ? this.minesAmount.substr(0, this.minesAmount.indexOf('.')) + '.' + this.minesAmount.substr((this.minesAmount.indexOf('.') + 1), 2).replace('.', '') : this.minesAmount;
            },
            minesIsCount(count) {
                return Number(this.minesCount) === count;
            },
            minesSetAmount(action) {
                if(action === 'clear') {
                    this.minesAmount = '';
                    return;
                }

                let amount = this.minesAmount === null || this.minesAmount === '' || isNaN(parseFloat(this.minesAmount)) ? 0 : parseFloat(this.minesAmount);
                const balance = this.authUser.user !== null ? this.authUser.user.balance : 0;

                if(action === 'min') {
                    amount = 0.1;
                } else if(action === '1/2') {
                    if(amount === 0) {
                        amount = 0.1;
                    } else {
                        amount = amount / 2;
                    }
                } else if(action === '2x') {
                    if(amount === 0) {
                        amount = 0.1;
                    } else {
                        amount = amount * 2;
                    }
                } else if(action === 'max') {
                    amount = balance;
                } else if(action === '10') {
                    amount = 10;
                } else if(action === '100') {
                    amount = 100;
                } else if(action === '1000') {
                    amount = 1000;
                } else if(action === '10000') {
                    amount = 10000;
                }

                // Ensure amount doesn't exceed balance
                if(amount > balance && balance > 0) {
                    amount = balance;
                }

                // Ensure minimum amount ($0.10)
                if(amount < 0.1) {
                    amount = 0.1;
                }

                // Format to 2 decimal places
                this.minesAmount = parseFloat(amount).toFixed(2);
            },
            minesSetCount(value) {
                this.minesCount = value;
            },
            setTab(tab) {
                this.currentTab = tab;
            },
            startAutoReveal() {
                // Clear any existing interval
                this.stopAutoReveal();

                // Start auto-reveal at 3-second intervals
                this.autoRevealInterval = setInterval(() => {
                    if (this.minesGame === null || this.minesGame.state === 'completed') {
                        this.stopAutoReveal();
                        return;
                    }

                    // Find an unrevealed tile
                    let tile = Math.floor(Math.random() * 25);
                    let attempts = 0;
                    
                    while (attempts < 25) {
                        // Check if tile is already revealed
                        const isRevealed = this.minesGame.revealed.some((element) => element.tile === tile);
                        if (!isRevealed) {
                            break;
                        }
                        tile = (tile + 1) % 25;
                        attempts++;
                    }

                    if (attempts < 25) {
                        const data = { tile: tile };
                        this.minesSendRevealSocket(data);
                    } else {
                        // All tiles revealed or game completed
                        this.stopAutoReveal();
                    }
                }, 3000);
            },
            stopAutoReveal() {
                if (this.autoRevealInterval !== null) {
                    clearInterval(this.autoRevealInterval);
                    this.autoRevealInterval = null;
                }
            },
            minesBetButton() {
                if(!this.authenticated) {
                    this.$root.$emit('open-signin-modal-app');
                    return;
                }

                const amount = this.minesAmount === null || this.minesAmount === '' ? 0 : parseFloat(parseFloat(this.minesAmount).toFixed(2));
                const minesCount = Math.floor(this.minesCount);
                const minBet = 0.1;

                if(isNaN(amount) === true || amount < minBet) {
                    this.notificationShow({type: 'error', message: `Minimum bet amount is $${minBet}.`});
                    return;
                }

                if(isNaN(minesCount) === true || minesCount < 1 || minesCount > 24) {
                    this.notificationShow({type: 'error', message: 'Your entered mines count is invalid.'});
                    return;
                }

                const data = { amount: amount, minesCount: minesCount };
                this.minesSendBetSocket(data);

                // If in auto mode, start auto-reveal after bet is placed
                if (this.currentTab === 'auto') {
                    // Wait for the game to start, then begin auto-reveal
                    this.$nextTick(() => {
                        // We'll start auto-reveal when the game state changes
                    });
                }
            },
            minesRevealButton() {
                let tile = Math.floor(Math.random() * (24 - this.minesGame.revealed.length));

                while(true) { 
                    if(this.minesGame.revealed.some((element) => element.tile === tile) === true) { tile = tile + 1; } 
                    else { break; }
                }

                const data = { tile: tile };
                this.minesSendRevealSocket(data);
            },
            minesCashoutButton() {
                this.stopAutoReveal();
                const data = {};
                this.minesSendCashoutSocket(data);
            },
            minesFairButton() {
                if(!this.authenticated) {
                    this.notificationShow({ type: 'error', message: 'Please sign in to perform this action.' });
                    return;
                }

                this.modalsSetShow('FairSeed')
            },
            minesMuteButton() {
                if(this.soundMines === 1) {
                    this.soundSetMines(0);
                } else {
                    this.soundSetMines(1);
                }
            },
            minesFactorialNumber(number) {
                let value = number;
                for (let i = number; i > 1; i--) {
                    value = value * (i - 1);
                }
                return value;
            }
        },
        watch: {
            'minesGame': {
                handler(newGame, oldGame) {
                    // Start auto-reveal when game starts in auto mode
                    if (this.currentTab === 'auto' && newGame !== null && newGame.state !== 'completed') {
                        if (oldGame === null || oldGame.state === 'completed') {
                            // Game just started
                            this.startAutoReveal();
                        }
                    }
                    
                    // Stop auto-reveal when game completes
                    if (newGame !== null && newGame.state === 'completed') {
                        this.stopAutoReveal();
                    }
                },
                deep: true
            }
        },
        computed: {
            ...mapGetters([
                'socketSendLoading',
                'soundMines',
                'authUser',
                'authenticated',
                'minesGame'
            ]),
            isInputDisabled() {
                return this.minesGame !== null && this.minesGame.state !== 'completed';
            },
            minesGetCashoutAmount() {
                let multiplier = 0;

                if(this.minesGame !== null && this.minesGame.revealed.length >= 1) {
                    const first = 25 === this.minesGame.revealed.length ? 1 : this.minesFactorialNumber(25) / (this.minesFactorialNumber(this.minesGame.revealed.length) * this.minesFactorialNumber(25 - this.minesGame.revealed.length));
                    const second = (25 - this.minesGame.minesCount) === this.minesGame.revealed.length ? 1 : this.minesFactorialNumber(25 - this.minesGame.minesCount) / (this.minesFactorialNumber(this.minesGame.revealed.length) * this.minesFactorialNumber((25 - this.minesGame.minesCount) - this.minesGame.revealed.length));

                    multiplier = 0.95 * (first / second);
                    multiplier = multiplier < 1 ? 1.01 : multiplier;
                    multiplier = Math.round(multiplier * 100) / 100;
                }

                return this.minesGame.amount * multiplier;
            }
        },
        beforeDestroy() {
            this.stopAutoReveal();
        }
    }
</script>

<style scoped>
    .mines-controls {
        width: 30%;
        display: flex;
        flex-direction: column;
        padding: 20px;
        border-radius: 25px;
        background: var(--bg-table-background);
    }

    /* Desktop: Manual/Auto first (order -1), then Bet section, then controls-top */
    .mines-controls .controls-tabs {
        order: -1;
        width: 100%;
        display: flex;
        gap: 0;
        margin-bottom: 20px;
        position: relative;
        background: var(--bg-blue-dark);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 100px;
        padding: 2px;
    }

    .mines-controls .tab-button {
        flex: 1;
        height: 36px;
        position: relative;
        padding: 0;
        border: none;
        background: transparent;
        cursor: pointer;
        transition: all 0.3s ease;
        z-index: 1;
    }

    .mines-controls .tab-button:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }

    .mines-controls .tab-button .tab-inner {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        font-weight: 700;
        color: #ffffff;
        background: transparent;
        border: none;
        border-radius: 100px;
        transition: all 0.3s ease;
        text-transform: uppercase;
        position: relative;
        z-index: 2;
    }

    .mines-controls .tab-button.tab-active .tab-inner {
        color: #ffffff;
        background: var(--gradient-purple-btn-bg);
        border: none;
    }

    .mines-controls .tab-button:not(:disabled):hover .tab-inner {
        color: #ffffff;
        background: transparent;
    }

    .mines-controls .tab-button.tab-active:not(:disabled):hover .tab-inner {
        color: #ffffff;
        background: var(--gradient-purple-btn-bg);
    }

    .mines-controls .balance-section {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 16px;
        margin-bottom: 16px;
        background: rgba(255, 255, 255, 0.05);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 12px;
    }

    .mines-controls .balance-label {
        font-size: 13px;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.7);
    }

    .mines-controls .balance-display {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .mines-controls .balance-display svg {
        width: 18px;
        height: 18px;
        flex-shrink: 0;
    }

    .mines-controls .balance-value {
        font-size: 16px;
        font-weight: 700;
        color: #ffffff;
    }

    /* Mobile-only Place Bet row: hidden on desktop */
    .mines-controls .place-bet-row-mobile {
        display: none;
    }

    /* Desktop: hide mobile duplicate (no-op, mobile row already hidden) */
    .mines-controls .controls-top {
        width: 100%;
    }

    .mines-controls .top-bet-section {
        width: 100%;
        margin-bottom: 20px;
    }

    .mines-controls .bet-label {
        font-size: 12px;
        font-weight: 600;
        color: #ffffff;
        margin-bottom: 8px;
    }

    .mines-controls .bet-input-container {
        width: 100%;
        height: 56px;
        display: flex;
        align-items: center;
        background: var(--bg-blue-dark);
        border-radius: 16px;
        padding: 0 16px;
        gap: 12px;
        border: 1px solid rgba(255, 255, 255, 0.08);
    }

    .mines-controls .bet-icon-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        flex-shrink: 0;
        color: rgba(255, 255, 255, 0.9);
    }

    .mines-controls .bet-icon-wrapper svg {
        width: 22px;
        height: 22px;
    }

    .mines-controls .bet-separator {
        width: 1px;
        height: 28px;
        background: rgba(255, 255, 255, 0.15);
        flex-shrink: 0;
    }

    .mines-controls .bet-value-display {
        flex: 1;
        min-width: 80px;
        display: flex;
        align-items: center;
        cursor: text;
        position: relative;
        z-index: 2;
    }

    .mines-controls .bet-value-input {
        width: 100%;
        min-width: 60px;
        min-height: 40px;
        background: transparent;
        border: none;
        outline: none;
        font-size: 16px;
        font-weight: 600;
        color: #e8e8e8;
        padding: 0 10px;
        text-align: left;
        cursor: text;
        border-radius: 10px;
        transition: background 0.2s ease, box-shadow 0.2s ease;
        position: relative;
        z-index: 2;
        pointer-events: auto;
        -webkit-user-select: text;
        user-select: text;
    }

    .mines-controls .bet-value-input::placeholder {
        color: rgba(255, 255, 255, 0.4);
    }

    .mines-controls .bet-value-input:hover:not(:disabled) {
        background: rgba(255, 255, 255, 0.04);
    }

    .mines-controls .bet-value-input:focus {
        background: rgba(255, 255, 255, 0.06);
        box-shadow: none;
    }

    .mines-controls .bet-value-input:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }

    .mines-controls .bet-quick-actions {
        margin-top: 10px;
        display: flex;
        align-items: center;
        gap: 10px;
        flex-shrink: 0;
    }

    .mines-controls .quick-action-btn {
        min-width: 44px;
        height: 36px;
        padding: 0 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--accent-btn-purple);
        border: 1px solid rgba(255, 255, 255, 0.15);
        border-radius: 12px;
        color: #ffffff;
        font-size: 12px;
        font-weight: 700;
        cursor: pointer;
        transition: all 0.2s ease;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    }

    .mines-controls .quick-action-btn:hover:not(:disabled) {
        background: var(--accent-btn-light-purple);
        border-color: rgba(255, 255, 255, 0.2);
        box-shadow: 0 3px 10px rgba(72, 58, 160, 0.4);
        transform: translateY(-1px);
    }

    .mines-controls .quick-action-btn:disabled {
        cursor: not-allowed;
        opacity: 0.5;
        transform: none;
    }

    .mines-controls .quick-action-btn.max-btn {
        border-radius: 12px;
        padding: 0 14px;
    }

    .mines-controls .bet-preset-buttons {
        width: 100%;
        display: flex;
        gap: 10px;
        margin-top: 14px;
    }

    .mines-controls .preset-btn {
        flex: 1;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--accent-btn-purple);
        border: 1px solid rgba(255, 255, 255, 0.15);
        border-radius: 12px;
        color: #ffffff;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        transition: all 0.2s ease;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    }

    .mines-controls .preset-btn:hover:not(:disabled) {
        background: var(--accent-btn-light-purple);
        border-color: rgba(255, 255, 255, 0.2);
        box-shadow: 0 3px 10px rgba(72, 58, 160, 0.4);
        transform: translateY(-1px);
    }

    .mines-controls .preset-btn:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }

    .mines-controls .top-mines {
        width: 100%;
    }

    .mines-controls .mines-label {
        font-size: 12px;
        font-weight: 600;
        color: #ffffff;
        margin-bottom: 8px;
    }

    .mines-controls .mines-slider-container {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 8px;
        background: var(--bg-blue-dark);
        border-radius: 100px;
        padding: 8px 12px;
    }

    .mines-controls .slider-end-label {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--bg-blue-dark);
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 50%;
        color: #ffffff;
        font-size: 14px;
        font-weight: 600;
        flex-shrink: 0;
    }

    .mines-controls .slider-end-label.mines-display {
        font-size: 14px;
        font-weight: 600;
    }

    .mines-controls .top-slider {
        flex: 1;
        position: relative;
        height: 16px;
        background: var(--bg-blue-chat);
        border-radius: 10px;
    }

    .mines-controls .top-slider input {
        width: 100%;
        height: 12px;
        position: relative;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background: transparent;
        border-radius: 6px;
        outline: none;
        cursor: pointer;
        z-index: 2;
    }

    .mines-controls .top-slider input::-webkit-slider-track {
        width: 100%;
        height: 12px;
        background: var(--bg-blue-dark);
        border-radius: 6px;
        border: 1px solid rgba(255, 255, 255, 0.1);
    }

    .mines-controls .top-slider input::-moz-range-track {
        width: 100%;
        height: 12px;
        background: var(--bg-blue-dark);
        border-radius: 6px;
        border: 1px solid rgba(255, 255, 255, 0.1);
    }

    .mines-controls .top-slider input::-webkit-slider-thumb {
        width: 24px;
        height: 24px;
        -webkit-appearance: none;
        appearance: none;
        background: var(--gradient-purple-btn-bg);
        border-radius: 50%;
        border: 3px solid #ffffff;
        cursor: pointer;
        margin-top: -6px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    .mines-controls .top-slider input::-moz-range-thumb {
        width: 24px;
        height: 24px;
        background: var(--gradient-purple-btn-bg);
        border-radius: 50%;
        border: 3px solid #ffffff;
        cursor: pointer;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    .mines-controls .top-slider::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        width: calc((var(--slider-value, 1) - 1) / 23 * 100%);
        height: 12px;
        background: var(--gradient-purple-btn-bg);
        border-radius: 6px 0 0 6px;
        transform: translateY(-50%);
        pointer-events: none;
        z-index: 1;
    }

    .mines-controls .top-slider input {
        position: relative;
        z-index: 2;
    }

    .mines-controls button.button-bet,
    .mines-controls button.button-cashout,
    .mines-controls button.button-random,
    .mines-controls button.button-auto {
        width: 100%;
        height: 44px;
        position: relative;
        z-index: 1;
        border: none;
        background: transparent;
        cursor: pointer;
        outline: none;
    }

    .mines-controls button.button-bet:disabled,
    .mines-controls button.button-cashout:disabled,
    .mines-controls button.button-random:disabled,
    .mines-controls button.button-auto:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }

    .mines-controls button.button-bet,
    .mines-controls button.button-cashout {
        margin-top: 25px;
        padding: 0;
        filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.1));
    }

    .mines-controls button.button-random,
    .mines-controls button.button-auto {
        margin-top: 13px;
        padding: 0;
        filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.1));
    }

    .mines-controls button.button-cashout::after {
        content: '';
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        position: absolute;
        top: 1px;
        left: 1px;
        background-color: #2a2a2a;
        border-radius: 12px;
        z-index: -1;
    }

    .mines-controls button.button-bet .button-inner,
    .mines-controls button.button-cashout .button-inner,
    .mines-controls button.button-random .button-inner,
    .mines-controls button.button-auto .button-inner {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        /*border: 1px solid var(--accent-yellow);*/
        background: var(--gradient-button-bg);
        box-sizing: border-box;
        transition: opacity 0.2s ease;
        position: relative;
        color: #ffffff;
    }

    .mines-controls button.button-bet .button-inner {
        background: var(--gradient-purple-btn-bg);
    }

    .mines-controls button.button-cashout .button-inner {
        background: var(--gradient-button-bg);
    }

    .mines-controls button.button-random .button-inner,
    .mines-controls button.button-auto .button-inner {
        font-size: 14px;
        font-weight: 700;
        color: var(--accent-btn-txt-color);
        background: var(--gradient-button-bg);
    }

    .mines-controls button.button-random .button-inner svg {
        width: 16px;
        height: 16px;
        margin-right: 8px;
        flex-shrink: 0;
    }

    .mines-controls button.button-random:enabled:hover .button-inner,
    .mines-controls button.button-auto:enabled:hover .button-inner {
        color: var(--accent-btn-txt-color);
        opacity: 0.9;
    }

    .mines-controls button.button-random:active .button-inner,
    .mines-controls button.button-auto:active .button-inner {
        opacity: 0.8;
    }

    .mines-controls button.button-bet .button-loading.fade-leave-active,
    .mines-controls button.button-cashout .button-loading.fade-leave-active,
    .mines-controls button.button-random .button-loading.fade-leave-active {
        transition: opacity 0.1s;
    }

    .mines-controls button.button-bet .button-loading.fade-leave-to,
    .mines-controls button.button-cashout .button-loading.fade-leave-to,
    .mines-controls button.button-random .button-loading.fade-leave-to {
        opacity: 0;
    }

    .mines-controls button.button-bet .inner-content.fade-enter-active,
    .mines-controls button.button-cashout .inner-content.fade-enter-active,
    .mines-controls button.button-random .inner-content.fade-enter-active {
        transition: opacity 0.1s;
    }

    .mines-controls button.button-bet .inner-content.fade-enter,
    .mines-controls button.button-cashout .inner-content.fade-enter,
    .mines-controls button.button-random .inner-content.fade-enter {
        opacity: 0;
    }

    .mines-controls button.button-bet .inner-content,
    .mines-controls button.button-cashout .inner-content,
    .mines-controls button.button-random .inner-content {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        font-weight: 800;
        /*color: var(--accent-btn-txt-color);*/
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    
    .mines-controls button.button-bet .button-loading,
    .mines-controls button.button-cashout .button-loading,
    .mines-controls button.button-random .button-loading,
    .mines-controls button.button-auto .button-loading {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        max-width: none;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .mines-controls button.button-cashout .content-amount {
        display: flex;
        align-items: center;
        margin-left: 11px;
    }

    .mines-controls button.button-cashout .content-amount svg {
        width: 13px;
        height: 13px;
        margin-right: 6px;
    }

    .mines-controls button.button-cashout .amount-value {
        font-size: 10px;
        font-weight: 600;
        color: #6a88a1;
    }

    .mines-controls button.button-cashout .amount-value span {
        font-size: 13px;
        font-weight: 800;
        color: var(--accent-btn-txt-color);
    }

    .mines-controls .controls-info {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .mines-controls .controls-info button {
        width: calc(50% - 6px);
        height: 32px;
        filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.1));
    }

    .mines-controls .controls-info button:first-of-type {
        margin-right: 12px;
    }

    .mines-controls .controls-info button .button-inner {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        font-weight: 700;
        color: var(--accent-btn-txt-color);
        background: var(--gradient-button-bg);
        border: 1px solid var(--accent-yellow);
        transition: color 0.3s ease;
        border-radius: 8px;
    }

    .mines-controls .controls-info button:hover .button-inner {
        color: var(--accent-btn-txt-color);
    }

    .mines-controls .controls-info button .button-inner svg {
        margin-right: 6px;
        fill: var(--accent-btn-txt-color);
        transition: fill 0.3s ease;
    }

    .mines-controls .controls-info button:hover .button-inner svg {
        fill: var(--accent-yellow);
    }

    @media only screen and (max-width: 850px) {

        .mines-controls {
            width: 100%;
            margin-top: 8px;
        }

        /* Mobile: Place Bet first, then Your Bet (higher up), then Manual/Auto, then rest */
        .mines-controls .place-bet-row-mobile {
            display: block;
            width: 100%;
            margin-bottom: 8px;
            order: 0;
        }

        .mines-controls .top-bet-section {
            order: 1;
            margin-bottom: 10px;
        }

        /* Ensure bet input coin icon is visible on mobile (no clipping/collapse) */
        .mines-controls .bet-input-container {
            overflow: visible;
        }

        .mines-controls .bet-icon-wrapper {
            min-width: 36px;
            min-height: 36px;
            flex-shrink: 0;
        }

        .mines-controls .bet-icon-wrapper svg {
            width: 22px;
            height: 22px;
            min-width: 22px;
            min-height: 22px;
        }

        .mines-controls .controls-tabs {
            order: 2;
        }

        .mines-controls .controls-top {
            order: 3;
        }

        .mines-controls .place-bet-row-mobile .button-bet,
        .mines-controls .place-bet-row-mobile .button-cashout {
            margin-top: 0;
        }

        .mines-controls .button-bet-desktop,
        .mines-controls .button-cashout-desktop {
            display: none;
        }

        .mines-controls .balance-section {
            padding: 10px 14px;
            margin-bottom: 12px;
        }

        .mines-controls .balance-label {
            font-size: 12px;
        }

        .mines-controls .balance-display svg {
            width: 16px;
            height: 16px;
        }

        .mines-controls .balance-value {
            font-size: 15px;
        }

        .mines-controls .controls-top {
            display: flex;
            flex-direction: column;
        }

        /* Reorder elements on mobile: PLACE BET first, then inputs, then RANDOM PICK */
        .mines-controls button.button-bet,
        .mines-controls button.button-cashout {
            order: 1;
            margin-top: 0;
            margin-bottom: 15px;
        }

        .mines-controls .top-amount {
            order: 2;
        }

        .mines-controls .top-slider {
            order: 3;
        }

        .mines-controls .top-mines {
            order: 4;
        }

        .mines-controls button.button-random,
        .mines-controls button.button-auto {
            order: 5;
            margin-top: 15px;
        }

        .mines-controls .controls-info {
            margin-top: 18px;
        }

    }

    @media only screen and (max-width: 575px) {


        .mines-controls .balance-section {
            padding: 8px 12px;
            margin-bottom: 10px;
        }

        .mines-controls .balance-label {
            font-size: 11px;
        }

        .mines-controls .balance-display svg {
            width: 15px;
            height: 15px;
        }

        .mines-controls .balance-value {
            font-size: 14px;
        }

    }

    @media only screen and (max-width: 425px) {


        .mines-controls .balance-section {
            padding: 8px 10px;
            margin-bottom: 10px;
        }

        .mines-controls .balance-label {
            font-size: 11px;
        }

        .mines-controls .balance-display {
            gap: 6px;
        }

        .mines-controls .balance-display svg {
            width: 14px;
            height: 14px;
        }

        .mines-controls .balance-value {
            font-size: 13px;
        }

    }

    @media only screen and (max-width: 350px) {


    }
</style>